/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportCreationInterval } from './ReportCreationInterval';
import {
    ReportCreationIntervalFromJSON,
    ReportCreationIntervalFromJSONTyped,
    ReportCreationIntervalToJSON,
    ReportCreationIntervalToJSONTyped,
} from './ReportCreationInterval';
import type { ReportConfigLayoutRepresentation } from './ReportConfigLayoutRepresentation';
import {
    ReportConfigLayoutRepresentationFromJSON,
    ReportConfigLayoutRepresentationFromJSONTyped,
    ReportConfigLayoutRepresentationToJSON,
    ReportConfigLayoutRepresentationToJSONTyped,
} from './ReportConfigLayoutRepresentation';
import type { ReportReferenceDate } from './ReportReferenceDate';
import {
    ReportReferenceDateFromJSON,
    ReportReferenceDateFromJSONTyped,
    ReportReferenceDateToJSON,
    ReportReferenceDateToJSONTyped,
} from './ReportReferenceDate';

/**
 * 
 * @export
 * @interface ReportConfigCreateRequest
 */
export interface ReportConfigCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportConfigCreateRequest
     */
    dashboardKey: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigCreateRequest
     */
    portfolioKey: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigCreateRequest
     */
    reportType: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigCreateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigCreateRequest
     */
    subtitle: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReportConfigCreateRequest
     */
    createAutomatically?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReportConfigCreateRequest
     */
    createAt?: number;
    /**
     * 
     * @type {ReportReferenceDate}
     * @memberof ReportConfigCreateRequest
     */
    referenceDate?: ReportReferenceDate;
    /**
     * 
     * @type {ReportCreationInterval}
     * @memberof ReportConfigCreateRequest
     */
    creationInterval?: ReportCreationInterval;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportConfigCreateRequest
     */
    sentToEmail?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigCreateRequest
     */
    layoutGenerationPolicy?: string;
    /**
     * 
     * @type {Array<ReportConfigLayoutRepresentation>}
     * @memberof ReportConfigCreateRequest
     */
    layouts?: Array<ReportConfigLayoutRepresentation>;
    /**
     * 
     * @type {boolean}
     * @memberof ReportConfigCreateRequest
     */
    storeInDocuments?: boolean;
    /**
     * The ISO 639 code for the language of the report
     * @type {string}
     * @memberof ReportConfigCreateRequest
     */
    language?: string;
}



/**
 * Check if a given object implements the ReportConfigCreateRequest interface.
 */
export function instanceOfReportConfigCreateRequest(value: object): value is ReportConfigCreateRequest {
    if (!('dashboardKey' in value) || value['dashboardKey'] === undefined) return false;
    if (!('portfolioKey' in value) || value['portfolioKey'] === undefined) return false;
    if (!('reportType' in value) || value['reportType'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('subtitle' in value) || value['subtitle'] === undefined) return false;
    return true;
}

export function ReportConfigCreateRequestFromJSON(json: any): ReportConfigCreateRequest {
    return ReportConfigCreateRequestFromJSONTyped(json, false);
}

export function ReportConfigCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportConfigCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dashboardKey': json['dashboardKey'],
        'portfolioKey': json['portfolioKey'],
        'reportType': json['reportType'],
        'title': json['title'],
        'subtitle': json['subtitle'],
        'createAutomatically': json['createAutomatically'] == null ? undefined : json['createAutomatically'],
        'createAt': json['createAt'] == null ? undefined : json['createAt'],
        'referenceDate': json['referenceDate'] == null ? undefined : ReportReferenceDateFromJSON(json['referenceDate']),
        'creationInterval': json['creationInterval'] == null ? undefined : ReportCreationIntervalFromJSON(json['creationInterval']),
        'sentToEmail': json['sentToEmail'] == null ? undefined : json['sentToEmail'],
        'layoutGenerationPolicy': json['layoutGenerationPolicy'] == null ? undefined : json['layoutGenerationPolicy'],
        'layouts': json['layouts'] == null ? undefined : ((json['layouts'] as Array<any>).map(ReportConfigLayoutRepresentationFromJSON)),
        'storeInDocuments': json['storeInDocuments'] == null ? undefined : json['storeInDocuments'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function ReportConfigCreateRequestToJSON(json: any): ReportConfigCreateRequest {
    return ReportConfigCreateRequestToJSONTyped(json, false);
}

export function ReportConfigCreateRequestToJSONTyped(value?: ReportConfigCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dashboardKey': value['dashboardKey'],
        'portfolioKey': value['portfolioKey'],
        'reportType': value['reportType'],
        'title': value['title'],
        'subtitle': value['subtitle'],
        'createAutomatically': value['createAutomatically'],
        'createAt': value['createAt'],
        'referenceDate': ReportReferenceDateToJSON(value['referenceDate']),
        'creationInterval': ReportCreationIntervalToJSON(value['creationInterval']),
        'sentToEmail': value['sentToEmail'],
        'layoutGenerationPolicy': value['layoutGenerationPolicy'],
        'layouts': value['layouts'] == null ? undefined : ((value['layouts'] as Array<any>).map(ReportConfigLayoutRepresentationToJSON)),
        'storeInDocuments': value['storeInDocuments'],
        'language': value['language'],
    };
}

